import { useState } from "react";
import { useNavigate } from "react-router";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

interface CompletionDialogProps {
  open: boolean;
  onClose: () => void;
}

// Component implementation
function CompletionDialogComponent({ open, onClose }: CompletionDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        // Prevent dialog from closing when clicking outside
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      maxWidth="md"
      fullWidth
      aria-label="申請完了"
    >
      <DialogContent>
        <Box sx={{ py: 3, textAlign: "center" }}>
          <Typography variant="body1" sx={{ mt: 2 }}>
            申請が完了しました
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
}

// Render hooks implementation
export default function useCompletionDialog(redirectPath?: string) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
    // 閉じた後に指定されたパスに遷移
    if (redirectPath) {
      navigate(redirectPath);
    }
  };

  // Render function that returns the dialog component
  const renderDialog = () => (
    <CompletionDialogComponent open={open} onClose={closeDialog} />
  );

  return {
    openCompletionDialog: openDialog,
    renderCompletionDialog: renderDialog,
  };
}
